"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Address = void 0;
var index_1 = require("./index");
var Address = /** @class */ (function (_super) {
    __extends(Address, _super);
    function Address(props) {
        if (props === void 0) { props = {}; }
        var _this = _super.call(this, __assign(__assign({}, Address.defaultProps()), props)) || this;
        _super.prototype.set.call(_this, Address.defaultProps());
        _this.set(props);
        return _this;
    }
    Address.defaultProps = function () {
        return {
            name: null,
            line1: null,
            line2: null,
            country: null,
            state: null,
            region: null,
            province: null,
            zip: null
        };
    };
    return Address;
}(index_1.AbstractModelLight));
exports.Address = Address;
